import { Controller } from "@hotwired/stimulus"

// Auto-shows a Bootstrap toast element on connect. Attach directly to the
// `.toast` element you want surfaced.
//
// Usage:
//   <div class="toast toast-alert" data-controller="flash-toast">…</div>
export default class extends Controller {
  connect() {
    window.bootstrap?.Toast?.getOrCreateInstance(this.element).show()
  }
}
